var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-text-body-small text-center"},[_c('span',[_vm._v("אם כבר נרשמת ")]),_c('link-button',{attrs:{"text":"הכניסה מכאן"},on:{"click":_vm.goToLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }